import { render } from "./ContainerNoList.vue?vue&type=template&id=f5db2462"
import script from "./ContainerNoList.vue?vue&type=script&lang=js"
export * from "./ContainerNoList.vue?vue&type=script&lang=js"
script.render = render

export default script